export const StepsUserInputPropNames = {
    PICTURE: 'picture',
    PICTURE_MULTIPLE: 'picturesWithComments',
}

export const ProcessEvidenceStatuses = { TO_BE_CONFIRMED: 'TO_BE_CONFIRMED' }
